import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllSettlementChartsData } from "../../../redux/reducers/apiSlice";
// import { decryptedText } from "../../../data/DecrytedDatas";
import HorizontalBarchart from "../../components-react/HorizontalBarchart";
import { selectAuth } from "../../auth/auth.selector";
// import SelectDropdown from "../../components-react/SelectDropdown";
// import { timeTypes } from "../../../exports/ProfitShareData";

const SettlementGraph = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const { settlementChartsData } = useSelector((state) => state.api);
  const selectedGym = useSelector((state) => state?.filters?.selectedGym);
  // const selectedYear = useSelector((state) => state?.filters?.selectedYear);
  // const selectedMonth = useSelector((state) => state?.filters?.selectedMonth);

  const [selectedFilterType, setSelectedFilterType] = useState({
    label: "Monthly",
    value: "month",
  });

  const [chartsData, setChartsData] = useState(null);

  const selectedGymQueryParam = selectedGym
    ? `&gym_id=${selectedGym?.value}`
    : "";
  // const selectedYearParam = selectedYear ? `&year=${selectedYear?.value}` : "";
  // const selectedMonthParam = selectedMonth
  //   ? `&month=${selectedMonth?.value}`
  //   : "";
  const selectedFiltertypeParam = selectedFilterType
    ? `&filter_type=${selectedFilterType?.value}`
    : "";
  const queryParametersFor = `${selectedFiltertypeParam}${selectedGymQueryParam}`;

  useEffect(() => {
    dispatch(
      fetchAllSettlementChartsData({
        queryParameters: queryParametersFor,
        token: decryptedText?.token,
      })
    );
  }, [queryParametersFor, decryptedText]);

  useEffect(() => {
    if (settlementChartsData?.status && settlementChartsData?.data) {
      setChartsData(settlementChartsData.data);
    }
  }, [settlementChartsData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="settlementGraphContainer">
      <div className="settleGraphTitleAndFilter">
        <h5 className="tite">Settlement</h5>
        {/* <div className="filter">
          <SelectDropdown
            options={timeTypes}
            selectedOption={selectedFilterType}
            setSelectedOption={(selectedValue) =>
              setSelectedFilterType(selectedValue)
            }
            name=""
          />
        </div> */}
      </div>

      <div className="horizontalBars">
        <div className="settleGraphBody">
          <HorizontalBarchart chartsData={chartsData} />
        </div>
      </div>
    </div>
  );
};

export default SettlementGraph;
